import { createGlobalStyle } from 'styled-components';

const jsonToCSSVariables = (json: Record<string, string>) =>
  Object.entries(json)
    .map(([key, value]) => `--${key}: ${value};`)
    .join('\n');

export const GlobalStyles = createGlobalStyle<{ theme: any }>`
  :root {
    ${({ theme }) => jsonToCSSVariables(theme.token || {})}
    ${({ theme }) => jsonToCSSVariables(theme.designTokens || {})}
      box-sizing: border-box;
  }

  html {
    height: auto;
    min-height: 100%;
    margin: 0;
    padding: 0;
    font-family: var(--fontFamily);
  }
  body {
    margin: 0;
    padding: 0;
    font-family: var(--fontFamily);
    background: var(--color-background);
    color: var(--color-neutral-light);
  }
  @media (max-width: 768px) {
    body {
      background: var(--color-background-mobile);
    }
  }
  #root {
    height: 100%;
    min-height: 100vh;
  }

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  ::-webkit-scrollbar-button {
    width: 4px;
    height: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--color-background);
    border: 0px none #ffffff;
    border-radius: 100px;
  }

  ::-webkit-scrollbar-track {
    background: var(--colorBgHeader);
    border: 0px none #ffffff;
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  .drawer-open {
    /* Adicione estilos específicos para drawer se necessário */
  }

  .vert-modal.ant-modal-root .ant-modal-mask {
    background-color: rgba(51, 51, 51, 0.7) !important;
  }
  
  .welcome-footer-container .welcome-footer-box {
    color: var(--footer-color-font);
  }
  .welcome-footer-container .welcome-footer-box a {
    color: var(--footer-color-button-text);
  } 
  .button-fml {
    padding: var(--button-padding-fml) !important;
    box-shadow: var(--button-box-shadow-fml);
  }
`;

